/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppReleaseDto } from '../../models/app-release-dto';

export interface AppReleaseControllerFindAll$Params {
}

export function appReleaseControllerFindAll(http: HttpClient, rootUrl: string, params?: AppReleaseControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppReleaseDto>>> {
  const rb = new RequestBuilder(rootUrl, appReleaseControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppReleaseDto>>;
    })
  );
}

appReleaseControllerFindAll.PATH = '/api/app-releases';
